import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';

function* removeCampaignUsers({ payload: { id, values, onSuccess, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.modifiers.assignments.removeUsers, id, data: values });

    onSuccess && onSuccess(data.result);
    yield put(actions.removeCampaignUsersDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.removeCampaignUsersFailed,
      handledErrors,
      endpoint: api.modifiers.assignments.removeUsers.url
    });
  }
}

export const removeCampaignUsersSaga = takeEvery(types.REMOVE_CAMPAIGN_USERS_REQUEST, removeCampaignUsers);